import React from "react";

const AlignRight = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M21.75 5.25V18.75C21.75 18.9489 21.671 19.1397 21.5303 19.2803C21.3897 19.421 21.1989 19.5 21 19.5C20.8011 19.5 20.6103 19.421 20.4697 19.2803C20.329 19.1397 20.25 18.9489 20.25 18.75V5.25C20.25 5.05109 20.329 4.86032 20.4697 4.71967C20.6103 4.57902 20.8011 4.5 21 4.5C21.1989 4.5 21.3897 4.57902 21.5303 4.71967C21.671 4.86032 21.75 5.05109 21.75 5.25ZM17.25 7.5H3C2.60218 7.5 2.22064 7.65804 1.93934 7.93934C1.65804 8.22064 1.5 8.60218 1.5 9V15C1.5 15.3978 1.65804 15.7794 1.93934 16.0607C2.22064 16.342 2.60218 16.5 3 16.5H17.25C17.6478 16.5 18.0294 16.342 18.3107 16.0607C18.592 15.7794 18.75 15.3978 18.75 15V9C18.75 8.60218 18.592 8.22064 18.3107 7.93934C18.0294 7.65804 17.6478 7.5 17.25 7.5Z"
      fill="currentColor"
    />
  </svg>
);

export default AlignRight;
